export default __webpack_public_path__ + "static/media/FileCoin总部.65469ab4.jpg";